import { isMsalMsaAccount } from './isMsalMsaAccount';
/**
 * Map incoming MSAL user to the values MeControl expects.
 *
 * @constant
 * @param account data from MSAL/b2c user account to map
 * @returns mecontrol-friendly user data
 */
export const getMeControlIAccountFromAccountInfo = (account) => {
    var _a, _b, _c, _d;
    if (!(account === null || account === void 0 ? void 0 : account.idTokenClaims)) {
        return null;
    }
    const { name, email, 
    // emails,
    given_name, family_name, 
    // idp,
    upn, 
    // userIdentifier,
    login_hint, preferred_username, } = account.idTokenClaims;
    //should show email
    // const primaryEmail = emails?.[0] || email || login_hint;
    const usernameOrEmail = name ||
        email ||
        preferred_username ||
        login_hint ||
        given_name ||
        upn ||
        account.name ||
        account.username ||
        account.localAccountId;
    if (isMsalMsaAccount(account)) {
        return {
            memberName: usernameOrEmail,
            login_hint: usernameOrEmail,
            displayName: usernameOrEmail,
            firstName: given_name,
            lastName: family_name,
            sessionId: account.idTokenClaims.sid,
            cid: (_d = (_c = (_b = (_a = account.idTokenClaims.oid) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, `00000000-0000-0000-`, ``)) === null || _c === void 0 ? void 0 : _c.replace) === null || _d === void 0 ? void 0 : _d.call(_c, '-', ''),
        };
    }
    return {
        memberName: usernameOrEmail,
        login_hint: usernameOrEmail,
        displayName: usernameOrEmail,
        firstName: given_name,
        lastName: family_name,
        sessionId: account.idTokenClaims.sid,
        type: 'msaFed',
        cid: account.localAccountId,
    };
};
